'use client';

import { useSession } from 'next-auth/react';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export const ActivityTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { data: session, status, update } = useSession(); // Adjust based on your auth solution

  const url = `${pathname}?${searchParams.toString()}`;

  useEffect(() => {
    const trackActivity = async () => {
      if (pathname === '/') {
        return;
      }

      // Check if user is logged in
      if (status !== 'authenticated' || !session?.user) {
        return;
      }

      // Check if user role is consumer
      if (session.user.role !== 'consumer') {
        return;
      }

      if (session.user.lastActivePath === pathname) {
        return;
      }

      let payload = {
        lastActivePath: url,
        lastActivityEvent: 'page_view', // or any event type you want
      };

      try {
        await fetch(`${process.env.NEXT_PUBLIC_API_URL}/users/last-activity`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${session.accessToken}`,
          },
          body: JSON.stringify(payload),
        });

        await update({
          lastActivePath: pathname,
        });
      } catch (error) {
        console.error('Failed to track user activity:', error);
      }
    };

    trackActivity();
  }, [pathname, searchParams, session, status]);

  /* useEffect(() => {
    const trackActivity = async () => {
      // Check if user is logged in
      if (status !== 'authenticated' || !session?.user) {
        return;
      }

      if (pathname === '/') {
        return;
      }

      // Check if user role is consumer
      if (session.user.role !== 'consumer') {
        return;
      }

      await update({
        lastActivePath: url,
      });
    };

    trackActivity();
  }, [pathname, searchParams]); */
  return null;
};
